export default __webpack_public_path__ + "static/media/F_Forms.f29fcbf2.png";